export type TemplateTypes = {
  INVITATION: 'invitation';
  REMINDERS: 'reminder';
};

export const TemplateGroup: TemplateTypes = {
  INVITATION: 'invitation',
  REMINDERS: 'reminder',
};

export type TemplateType = {
  name: string;
  slug: string;
  subject: string;
  content: string;
  group: 'invitation' | 'reminder';
  id: number;
  type: 'custom' | 'default';
  text_content: string;
};
